import * as AppPics from 'assets/images';
import AppBreadcrumbs from 'components/molecules/AppBreadcrumbs';
import { notifier } from 'components/Toaster';
import { useQueryClient } from 'react-query';
import { useHistory } from 'react-router-dom';
import useGetLessonFeedback from 'hooks/API/GET/useGetLessonFeedback';
import useLessonFeedbackStatus from 'hooks/API/POST/useLessonFeedbackStatus';

function LessonFeedback() {
  const history = useHistory();
  const queryClient = useQueryClient();

  const { data, isLoading } = useGetLessonFeedback({ enabled: true });
  const feedbacks = data?.data?.data?.result ?? [];

  const { mutate: markReviewed } = useLessonFeedbackStatus();

  const handleMarkReviewed = (feedbackId) => {
    markReviewed(
      { feedbackId, status: 'reviewed' },
      {
        onSuccess: () => {
          notifier.success('Feedback marked as reviewed');
          queryClient.invalidateQueries('lesson-feedback');
        },
        onError: () => notifier.error('Failed to update status'),
      }
    );
  };

  const handleRowClick = (feedback) => {
    history.push(`/manage/lesson-feedback/${feedback._id}`, { feedback });
  };

  return (
    <div className="mainWraper coursetabsection">
      <div className="tab">
        <ul className="tab__menu">
          <li className="back">
            <button className="btn-back" onClick={() => history.goBack()}>
              <img src={AppPics.BackSvg} alt="Back" />
            </button>
          </li>
        </ul>

        <div className="tab__content ___adjust___tab___padding">
          <div className="tab__content-actHead">
            <AppBreadcrumbs current="Lesson Feedback" />
          </div>

          {isLoading ? (
            <p>Loading...</p>
          ) : feedbacks.length === 0 ? (
            <p className="text-center" style={{ padding: '40px 0', color: '#888' }}>
              No feedback submitted yet.
            </p>
          ) : (
            <div className="table-responsive">
              <table className="table">
                <thead>
                  <tr>
                    <th>Student</th>
                    <th>Course</th>
                    <th>Chapter</th>
                    <th>Lesson</th>
                    <th>Status</th>
                    <th>Date</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {feedbacks.map((fb) => (
                    <tr
                      key={fb._id}
                      style={{ cursor: 'pointer' }}
                      onClick={() => handleRowClick(fb)}
                    >
                      <td>{fb.user?.name || fb.user?.email || '—'}</td>
                      <td>{fb.course?.courseName || '—'}</td>
                      <td>{fb.chapter?.name || '—'}</td>
                      <td>{fb.topic?.name || '—'}</td>
                      <td>
                        <span
                          className={`badge badge-${fb.status === 'new' ? 'primary' : 'secondary'}`}
                        >
                          {fb.status === 'new' ? 'New' : 'Reviewed'}
                        </span>
                      </td>
                      <td>{new Date(fb.createdAt).toLocaleDateString()}</td>
                      <td onClick={(e) => e.stopPropagation()}>
                        {fb.status === 'new' && (
                          <button
                            className="btn btn-sm btn-success"
                            onClick={() => handleMarkReviewed(fb._id)}
                          >
                            Mark Reviewed
                          </button>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default LessonFeedback;
